import './ccf-back-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfBackIconProps extends SvgIconProps  {}
/**
 * Component used to display back arrow Icon
 * @param props - CcfBackIconProps
 * @example - <CcfBackIcon />
 * @returns SVG of back arrow Icon
 */
export function CcfBackIcon(props: CcfBackIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"/>
    </SvgIcon>
  );
}

export default CcfBackIcon;
